// MyListingsHeader.jsx
// Header component for ViewMyListings page

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { styles } from './styles';

// Modern SVG Icons
const PackageIcon = () => (
  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <line x1="16.5" y1="9.4" x2="7.5" y2="4.21" />
    <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
    <polyline points="3.27 6.96 12 12.01 20.73 6.96" />
    <line x1="12" y1="22.08" x2="12" y2="12" />
  </svg>
);

const PlusIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <line x1="12" y1="5" x2="12" y2="19" />
    <line x1="5" y1="12" x2="19" y2="12" />
  </svg>
);

const MyListingsHeader = () => {
  const navigate = useNavigate();

  return (
    <div style={styles.headerSection}>
      <div style={styles.headerContent}>
        <div style={styles.headerLeft}>
          <div style={styles.headerIconWrapper}>
            <PackageIcon />
          </div>
          <div>
            <h1 style={styles.pageTitle}>My Listings</h1>
            <p style={styles.pageSubtitle}>
              Manage and track your posted items
            </p>
          </div>
        </div>
        <button
          style={styles.addListingButton}
          onClick={() => navigate('/add-listing')}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = '#a00f20';
            e.currentTarget.style.transform = 'translateY(-2px)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = '#CE1126';
            e.currentTarget.style.transform = 'translateY(0)';
          }}
        >
          <PlusIcon />
          <span>Create Listing</span>
        </button>
      </div>
    </div>
  );
};

export default MyListingsHeader;